module.exports = __webpack_public_path__ + "static/media/records-not-found.e4914410.svg";